// Module
var code = "<div class=\"cancel-policy\"> <p>キャンセルについては、ご予約の3日前までにご連絡をお願いします。</p> <p>レストランによってキャンセル料が発生する場合があります。<br> 詳細は直接レストランにお問合わせください。</p> </div>";
// Exports
export default code;